export default __webpack_public_path__ + "static/media/tick.153cff59.svg";